export const languages = {
  en_US: "en",
  nl_NL: "nl"
};
